export const setMarketDataLayer = locale => {
    const localeArr = locale.split('-');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event' : 'initialized',
      'market' : localeArr[1],
      'language' : localeArr[0],
      'locale' : locale
    });   
}

export const setPageDataLayer = () => {
    window.dataLayer.push({
       'event': 'virtualPageView',
       'virtualPageTitle': "thankyou",
       'virtualPageURL': `/${sessionStorage.getItem('locale')}`
   });    
}